// Welcome-back card shown on the landing page to a returning verified visitor
// who has a saved draft. Rather than silently skipping them into the form, it
// acknowledges the resume, summarizes what was saved, and offers an explicit
// choice — Continue, start fresh, or sign out (shared-machine privacy).
import {
  Paper, Box, Typography, Button, Stack, Divider,
} from '@mui/material';

const WelcomeBackCard = ({
  contact, onContinue, onStartNew, onSignOut,
}) => {
  const firstName = (contact?.name || '').trim().split(/\s+/)[0];

  return (
    <Paper
      elevation={0}
      sx={{
        gridArea: 'form',
        p: { xs: 3, md: 4 },
        borderRadius: 3,
        maxWidth: 480,
        width: '100%',
        justifySelf: { md: 'end' },
        border: 1,
        borderColor: 'divider',
        borderTop: 3,
        borderTopColor: 'primary.main',
      }}
    >
      <Stack spacing={2}>
        <Box>
          <Typography variant="h5" component="h2" sx={{ fontWeight: 700 }}>
            {firstName ? `Welcome back, ${firstName}` : 'Welcome back'}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
            You have a saved request in progress.
          </Typography>
        </Box>

        <Button variant="contained" size="large" onClick={onContinue}>
          Continue my request
        </Button>
        <Button variant="outlined" onClick={onStartNew}>
          Start a new request
        </Button>

        <Divider />
        <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center' }}>
          {contact?.email}
        </Typography>
        <Button variant="text" size="small" onClick={onSignOut} sx={{ alignSelf: 'center' }}>
          Not you? Sign out
        </Button>
      </Stack>
    </Paper>
  );
};

export default WelcomeBackCard;
